import { render, staticRenderFns } from "./EventDescription.vue?vue&type=template&id=5bea8b50&scoped=true"
import script from "./EventDescription.vue?vue&type=script&lang=js"
export * from "./EventDescription.vue?vue&type=script&lang=js"
import style0 from "./EventDescription.vue?vue&type=style&index=0&id=5bea8b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea8b50",
  null
  
)

export default component.exports